import React from "react";

// Define Button Variants
const buttonVariants = {
  primaryNeutral: "bg-neutral-primary",
  primaryNeutralMid: "bg-neutral-secondary-mid",
  primaryBrick: "bg-brick-primary",
  primaryMoss: "bg-moss-primary",
  primaryStatusRed: "bg-status-bad",
  primaryStatusOrange: "bg-status-medium",
  primaryStatusGreen: "bg-status-good",
  secondaryNeutral:
    "text-neutral-primary! border border-neutral-primary hover:bg-neutral-primary hover:text-white!",
  secondaryNeutralMid:
    "border border-neutral-secondary-mid text-neutral-secondary-mid! hover:text-neutral-primary!",
  secondaryBrick:
    "text-brick-primary! border border-brick-primary hover:bg-brick-primary hover:text-white!",
  secondaryMoss:
    "text-moss-primary! border border-moss-primary hover:bg-moss-primary hover:text-white!",
  secondaryStatusRed:
    "text-status-bad! border border-status-bad hover:bg-status-bad hover:text-white!",
  secondaryStatusOrange:
    "text-status-medium! border border-status-medium hover:bg-status-medium hover:text-white!",
  secondaryStatusGreen:
    "text-status-good! border border-status-good hover:bg-status-good hover:text-white!",
};

// Button Props
interface ButtonProps {
  variant?: any;
  href?: string;
  target?: string;
  onClick?: (e?: any) => any;
  icon?: React.ReactElement;
  isDisabled?: boolean;
  label?: string;
  className?: string;
}

const ButtonNew: React.FC<ButtonProps> = ({
  variant = "primaryNeutral",
  href,
  target,
  onClick,
  icon,
  isDisabled = false,
  label,
  className,
}) => {
  const buttonClass = `gap-1.5 py-1.5 px-2.5 justify-center rounded-full text-white font-medium text-sm flex items-center hover:opacity-90 disabled:opacity-50 transition-all ${
    buttonVariants[variant as keyof typeof buttonVariants]
  } ${className || ""}`;
  const iconWithDefaultClass = icon
    ? React.cloneElement(icon, {
        className: `${icon.props.className || ""} w-[17px] h-[17px]`,
      })
    : null;

  return href ? (
    <a
      href={href}
      className={buttonClass}
      onClick={onClick}
      target={target ? target : "_self"}
    >
      {iconWithDefaultClass}
      {label}
    </a>
  ) : (
    <button disabled={isDisabled} className={buttonClass} onClick={onClick}>
      {iconWithDefaultClass}
      {label}
    </button>
  );
};

export default ButtonNew;
